import type { RouteObject } from 'react-router-dom';
import { PERMISSIONS } from '@optiflow/types';
import { RequirePermission } from '@/routes/RequirePermission';
import { FrameRecommendationsPage } from './pages/FrameRecommendationsPage';

/**
 * The recommendation screen's route, guarded for both things it needs: reading the customer, and asking for recommendations.
 *
 * Kept whole here so the route the app mounts is the route the tests exercise. The API refuses the same callers; this only keeps the screen from appearing for them.
 */
export const frameRecommendationRoute: RouteObject = {
  element: <RequirePermission permission={PERMISSIONS.CUSTOMERS_VIEW} />,
  children: [
    {
      element: <RequirePermission permission={PERMISSIONS.FRAME_RECOMMEND} />,
      children: [
        {
          path: '/customers/:customerId/frame-recommendations',
          element: <FrameRecommendationsPage />,
        },
      ],
    },
  ],
};
